import { Menu, MenuSquareIcon, SearchIcon, X } from 'lucide-react';
import Link from '../Link';
import "./navbar.css"


function MenuComponent({ isMenuVisible, isMenuVisible_, closeAll, toggleMenu }) {
    return (
        <>
            {isMenuVisible && (
                <div className={`overlay ${isMenuVisible_ && "active"}`} onClick={closeAll}>
                    <div className="menu-box" onClick={(e) => e.stopPropagation()}>
                        <div className="close-icon" onClick={toggleMenu}>
                            <X className="close-icon_" size={20} />
                            <p className='fonseca'>close</p>
                        </div>
                        <ul className="menu-list">
                            {["Home', 'Healing Party', 'Bible Study', 'Live in the Spirit', 'Events', 'Contact"].map((item, index) => (
                                <li key={index}>
                                    <Link to={`/${item.toLowerCase().replace(' ', '-')}`} onClick={closeAll}>
                                        {item}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    )
}


export default MenuComponent